import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const ANNOUNCEMENT_DELAY_MS = 100;

@Injectable()
export class ActivityEditAccessibilityAnnouncerService implements OnDestroy {
	public readonly message$ = new BehaviorSubject<string>('');
	private announcementTimeout: ReturnType<typeof setTimeout> | null = null;

	/**
	 * Keep the live region inside the aria-modal sidepanel. NVDA is more
	 * reliable with an in-panel live region than with global announcer nodes.
	 */
	public announce (message: string): void {
		if (this.announcementTimeout != null) {
			clearTimeout(this.announcementTimeout);
		}

		this.message$.next('');
		this.announcementTimeout = setTimeout(() => {
			this.message$.next(message);
			this.announcementTimeout = null;
		}, ANNOUNCEMENT_DELAY_MS);
	}

	public ngOnDestroy (): void {
		if (this.announcementTimeout != null) {
			clearTimeout(this.announcementTimeout);
			this.announcementTimeout = null;
		}
	}
}
